import { useTranslation } from 'react-i18next';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/Domain/components/Shared/Tabs/Tabs';
import { AiModelLoader } from '@/UI/Identity/AiModel/AiModel.loader';
import { ConversationStyleLoader } from '@/UI/Identity/ConversationStyle/ConversationStyle.loader';
import { LanguageSettingLoader } from '@/UI/Identity/LanguageSetting/LanguageSetting.loader';
import { ProfileLoader } from '@/UI/Identity/Profile/Profile.loader';

enum TabsEnum {
  Profile = 'profile',
  Style = 'style',
  Languages = 'languages',
  Model = 'model',
}

export const IdentityPage = () => {
  const { t } = useTranslation('identity');

  return (
    <div className="mx-auto w-full max-w-7xl">
      <h1 className="text-lg font-semibold text-foreground mb-6">{t('title')}</h1>
      <Tabs defaultValue={TabsEnum.Profile} id="tabs-identity">
        <TabsList className="mb-6" id="tabs-list">
          <TabsTrigger data-testid="tab-profile" value={TabsEnum.Profile}>
            {t('tabs.profile')}
          </TabsTrigger>
          <TabsTrigger data-testid="tab-style" value={TabsEnum.Style}>
            {t('tabs.conversation_style')}
          </TabsTrigger>
          <TabsTrigger data-testid="tab-languages" value={TabsEnum.Languages}>
            {t('tabs.languages')}
          </TabsTrigger>
          <TabsTrigger data-testid="tab-model" value={TabsEnum.Model}>
            {t('tabs.model')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value={TabsEnum.Profile} id="profile-content">
          <ProfileLoader />
        </TabsContent>
        <TabsContent value={TabsEnum.Style}>
          <ConversationStyleLoader />
        </TabsContent>
        <TabsContent value={TabsEnum.Languages}>
          <LanguageSettingLoader />
        </TabsContent>
        <TabsContent value={TabsEnum.Model}>
          <AiModelLoader />
        </TabsContent>
      </Tabs>
    </div>
  );
};
